import React from "react";
import { Container, Typography, Paper, Link, Box } from "@mui/material";
import Footer from "./Footer";
import SeoHead from "../Components/SEO/SeoHead";
import { BASE_SITE_URL } from "../config";
import { useTranslation } from "react-i18next";

const CookiePolicy = () => {
  const { t } = useTranslation();
  const introParagraphs = t("cookiePolicyPage.intro", { returnObjects: true }) as string[];
  const sections = t("cookiePolicyPage.sections", { returnObjects: true }) as {
    title: string;
    body: string;
  }[];
  const browserLinks = t("cookiePolicyPage.browsers", { returnObjects: true }) as {
    chrome: string;
    chromeLink: string;
    firefox: string;
    firefoxLink: string;
  };

  const cookieStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: t("cookiePolicyPage.seoTitle"),
    url: `${BASE_SITE_URL}/CookiePolicy`,
    description: t("cookiePolicyPage.structuredDataDescription"),
  };
  return (
    <Box
      id="cookie-policy-page"
      key={`mainContentBoxDiv`}
      sx={{
        backgroundColor: "background.default",
        color: "text.primary",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <SeoHead
        title={t("cookiePolicyPage.seoTitle")}
        description={t("cookiePolicyPage.seoDescription")}
        path="/CookiePolicy"
        keywords={["music tier list cookies", "cookie policy", "privacy", "music tier list security"]}
        structuredData={cookieStructuredData}
      />
      <Container maxWidth="md" sx={{ marginTop: 4 }}>
        <Paper sx={{ padding: 3 }}>
          <Box textAlign="center" marginBottom={4}>
            <Typography variant="h3" gutterBottom>
              {t("cookiePolicyPage.title")}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              <i>{t("cookiePolicyPage.updated")}</i>
            </Typography>
          </Box>

          {Array.isArray(introParagraphs) && introParagraphs.map((paragraph, index) => (
            <Typography key={index} variant="body1" paragraph>
              {paragraph}
            </Typography>
          ))}

          {Array.isArray(sections) && sections.map((section, index) => (
            <Box key={index} mb={2}>
              <Typography variant="h6" gutterBottom>
                {section.title}
              </Typography>
              <Typography variant="body1" paragraph>
                {section.body}
              </Typography>
            </Box>
          ))}

          <Typography variant="body1" paragraph>
            <strong>{browserLinks.chrome}</strong>
            <br />
            <Link href={browserLinks.chromeLink} target="_blank" color="inherit">
              {browserLinks.chromeLink}
            </Link>
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>{browserLinks.firefox}</strong>
            <br />
            <Link href={browserLinks.firefoxLink} target="_blank" color="inherit">
              {browserLinks.firefoxLink}
            </Link>
          </Typography>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default CookiePolicy;
